import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import "./groupBtn.scss";
import { CompassOutlined, InfoCircleOutlined, InsertRowBelowOutlined } from '@ant-design/icons';

interface LocationState {
    edit: boolean;
}

const GroupBtn: React.FC = () => {
    const [activeBtn, setActiveBtn] = useState<string | null>('btn1');
    const history = useHistory();
    const location = useLocation<LocationState>();

    useEffect(() => {
        // Determine active button based on the pathname
        switch (location.pathname) {
            case '/mobile-application/add-app':
                setActiveBtn('btn1');
                break;
            case '/mobile-application/add-screens':
                setActiveBtn('btn2');
                break;
            case '/mobile-application/flow':
                setActiveBtn('btn3');
                break;
            default:
                setActiveBtn(null);
                break;
        }
    }, [location.pathname]);

    const handleBtnClick = (btnName: string, route: string) => {
        setActiveBtn(btnName);
        if (location.state?.edit) {
            history.push({
                pathname: route,
                state: { ...location.state },
                // state: {
                //     ...(typeof history.location.state === 'object' ? history.location.state : location.state),
                // },

            });
        } else {
            history.push(route);
        }
    };

    return (
        <div className="group-button">
            <button className={activeBtn === "btn1" ? "btn1 active" : "btn1"} onClick={() => handleBtnClick("btn1", "/mobile-application/add-app")} disabled={!location.state?.edit}><InfoCircleOutlined /> <span>Info</span></button>
            <button className={activeBtn === "btn2" ? "btn2 active" : "btn2"} onClick={() => handleBtnClick("btn2", "/mobile-application/add-screens")} disabled={!location.state?.edit}><InsertRowBelowOutlined /> <span>Screens</span></button>
            <button className={activeBtn === "btn3" ? "btn3 active" : "btn3"} onClick={() => handleBtnClick("btn3", "/mobile-application/flow")} disabled={!location.state?.edit}> <CompassOutlined /> <span>Flow</span></button>
        </div>
    );
};

export default GroupBtn;
